// app功能开关配置
const functionSwitchConfig = {
    enableDivWatermark: false, // 是否启用div水印, 默认都是用canvas水印
}

export default functionSwitchConfig;